import { Switch, useRouteMatch } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoutes";
import { ClaimRewardProvider } from "contexts/claimReward";
import Account from "./Account";

import AccountBanks from "./AccountBanks";
import AccountBVN from "./AccountBVN";
import AccountEdit from "./AccountEdit";
import AccountRefer from "./AccountRefer";
import AccountReferList from "./AccountReferList";
import AccountReferDetails from "./AccountReferDetails";
// import AccountSupport from "./AccountSupport";
import AccountVerification from "./AccountVerificationIndex";

import CryptoAlertIndex from "./CrytoAlertIndex";
import AffiliatesIndex from "./AffiliatesIndex";
import MobileMoneyIndex from "./MobileMoneyIndex";

const AccountIndex = () => {
  const { path } = useRouteMatch();
  return (
    <ClaimRewardProvider>
      <Switch>
        <ProtectedRoute exact path={path} component={Account} />
        <ProtectedRoute path={`${path}/banks`} component={AccountBanks} />
        <ProtectedRoute path={`${path}/bvn`} component={AccountBVN} />
        <ProtectedRoute path={`${path}/edit`} component={AccountEdit} />
        <ProtectedRoute
          path={`${path}/refer/:listType/:id`}
          component={AccountReferDetails}
        />
        <ProtectedRoute
          path={`${path}/refer/:listType`}
          component={AccountReferList}
        />
        <ProtectedRoute path={`${path}/refer`} component={AccountRefer} />
        <ProtectedRoute
          path={`${path}/verification`}
          component={AccountVerification}
        />
        <ProtectedRoute
          path={`${path}/pricealert`}
          component={CryptoAlertIndex}
        />
        <ProtectedRoute path={`${path}/partners`} component={AffiliatesIndex} />
        <ProtectedRoute
          path={`${path}/mobilemoney`}
          component={MobileMoneyIndex}
        />
      </Switch>
    </ClaimRewardProvider>
  );
};

export default AccountIndex;
